"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _linechart_data = require("./linechart_data");

var _definitionhelpers = require("../../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- LINECHART : DEFINITION --------------- ++++++++++ */


var _default = {
  name: 'LineChart',
  group: _definitionhelpers.groupNames.charts,
  props: {
    type: {
      type: 'string',
      default: 'overview',
      options: ['overview', 'detail']
    },
    label: {
      type: 'string',
      default: 'Add a Label'
    },
    value: {
      type: 'string',
      default: '$X,XXX.XXX'
    },
    tooltip: {
      type: 'string',
      default: 'Add your tooltip here'
    },
    yType: {
      type: 'string',
      default: 'dollar',
      options: ['dollar', 'percent']
    },
    xType: {
      type: 'string',
      default: 'date',
      options: ['date']
    },
    data: {
      type: 'array',
      default: _linechart_data.overviewData
    },
    loading: {
      type: 'boolean',
      default: false,
      options: [true, false]
    },
    height: {
      type: 'number',
      default: 300
    },
    width: {
      type: 'number',
      default: 400
    },
    moreDetails: {
      type: 'object',
      default: {
        type: 'action',
        text: 'small chart more detail cta',
        color: 'action',
        action: function action() {
          return alert('No Data chart link');
        }
      },
      disabled: true,
      help: _definitionhelpers.helpMessages.functions
    }
  }
};
exports.default = _default;